import { render } from "./PWAInstallButton.vue?vue&type=template&id=0f508d80&scoped=true"
import script from "./PWAInstallButton.vue?vue&type=script&lang=js"
export * from "./PWAInstallButton.vue?vue&type=script&lang=js"

import "./PWAInstallButton.vue?vue&type=style&index=0&id=0f508d80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f508d80"]])

export default __exports__